import { PlusOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import React, { useEffect, useState } from 'react'
import RepoLookupList from './RepoLookupList';
import RepoLookup from './RepoLookup';
import service from '../../../services/documentRepoService'
import { recordError } from "../../../utils/logService";

export default function RepoLookupView({ }) {

    const mainTitle = "Document Repository - Dropdown Configuration";
    const [visible, setVisible] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(true);
    const [modalType, setModalType] = useState("add");
    const [organisationTypes, setOrganisationTypes] = useState([]);

    const docCategory = "Document Category";
    const docType = "Document Type";
    const affiliatedOrg = "Affiliated Organisation";
    const organisation = "Organisation";
    const funding = "Funding Agency";

    const knownDropdowns = [
        { key: affiliatedOrg, value: affiliatedOrg, active: false },
        { key: organisation, value: organisation, active: true },
        { key: docCategory, value: docCategory, active: true },
        { key: docType, value: docType, active: true },
        { key: funding, value: funding, active: false },
    ];

    useEffect(() => {
        if (hasUpdated) {
            getOrganisationTypes();
        }
    }, [organisationTypes]);

    const showModal = (record, type) => {
        setVisible(record);
        setModalType(type)
    };

    const getOrganisationTypes = async () => {
        try {
            const response = await service.getOrganisationTypes();
            if (response && response.status === 200) {
                const { data } = response;
                const sorted = data.sort((a, b) => a.value.localeCompare(b.value));
                setOrganisationTypes(sorted);
            } else {
                setOrganisationTypes([]);
            }
            setHasUpdated(false);
        } catch (error) {
            recordError(error);
        }
    };

    return (
        <>
            <div className="content">
                <Col xs={24}>
                    <h1 className="center-align">{mainTitle}</h1>
                </Col>
                <Button
                    className="add-button"
                    key="add-button-1"
                    type="primary"
                    onClick={() => showModal({}, "add")}
                    icon={<PlusOutlined />}
                >
                    {""} Add New Option
                </Button>
                <RepoLookup
                    key={"RepoLookup2"}
                    type={modalType}
                    record={visible}
                    onShow={showModal}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                    dropdownLookups={knownDropdowns}
                    organisationTypes={organisationTypes}
                />
                <RepoLookupList
                    key={"RepoLookupList3"}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                    showModal={showModal}
                    organisationTypes={organisationTypes}
                />
            </div>
        </>
    );
}
